import { Sheet } from "lucide-react";
import React, { useState } from "react";
import axios from "axios";
import { base_url } from "../../config";
import Spinner from "../../components/Spinner/Spinner";

export default function App() {
  const [processingDownloadRegistrations, setProcessingDownloadRegistrations] =
    useState(false);
  const [processingDownloadPapers, setProcessingDownloadPapers] =
    useState(false);
  const reports = [
    {
      id: 1,
      title: "Registration Breakdown",
      description: "Detailed breakdown of registrations",
    },
    {
      id: 2,
      title: "Paper Report",
      description:
        "Papers accepted, their registration status, and presentation details",
    },

    /*{
      id: 3,
      title: "Workshop Participation",
      description: "Attendance and participation data for all workshops",
    },
    {
      id: 4,
      title: "Membership",
      description: "Current membership status and demographic information",
    },*/
  ];

  const handleDownload = async (reportTitle: string) => {
    switch (reportTitle) {
      case "Registration Breakdown":
        setProcessingDownloadRegistrations(true);
        break;
      case "Paper Report":
        setProcessingDownloadPapers(true);
        break;
      default:
        break;
    }
    try {
      const response = await axios.post(
        `${base_url}/api/admin/reports`,
        { title: reportTitle },
        { responseType: "blob" }
      );
      const pdfBlob = new Blob([response.data], { type: "application/xlsx" });

      const url = window.URL.createObjectURL(pdfBlob);
      const tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.setAttribute("download", `${reportTitle}.xlsx`); // Set the desired filename for the downloaded file

      // Append the <a> element to the body and click it to trigger the download
      document.body.appendChild(tempLink);
      tempLink.click();

      // Clean up the temporary elements and URL
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading report: ", error);
      alert("Failed to download report. Please try again later.");
    } finally {
      switch (reportTitle) {
        case "Registration Breakdown":
          setProcessingDownloadRegistrations(false);
          break;
        case "Paper Report":
          setProcessingDownloadPapers(false);
          break;
        default:
          break;
      }
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="mb-8">
        <div className="text-2xl mt-4 pb-4 font-bold flex gap-8 items-center">
          <Sheet />
          Exports
        </div>
        <p className="text-gray-600">Download your reports in Excel format</p>
      </div>

      <div className="space-y-4">
        {reports.map((report) => (
          <div
            key={report.id}
            className="flex items-center justify-between p-6 bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900 mb-1">
                {report.title}
              </h3>
              <p className="text-gray-600 text-sm">{report.description}</p>
            </div>

            <button
              onClick={() => handleDownload(report.title)}
              className="ml-6 px-6 py-2 bg-green-600 text-white font-medium 
                        rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 
                          focus:ring-offset-2 transition-colors
                          disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={
                (report.title === "Registration Breakdown" &&
                  processingDownloadRegistrations) ||
                (report.title === "Paper Report" && processingDownloadPapers)
              }
            >
              {report.title === "Registration Breakdown" &&
                (processingDownloadRegistrations ? (
                  <>
                    <span>Processing...</span>
                  </>
                ) : (
                  "Download Excel"
                ))}
              {report.title === "Paper Report" &&
                (processingDownloadPapers ? (
                  <>
                    <span>Processing...</span>
                  </>
                ) : (
                  "Download Excel"
                ))}

              {/* Show loading state if the report is being processed */}
            </button>
          </div>
        ))}
      </div>

      <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg
              className="h-5 w-5 text-blue-400 mt-0.5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-blue-800">
              Export Information
            </h3>
            <div className="mt-1 text-sm text-blue-700">
              <p>
                All reports are generated in real-time and exported in Excel
                (.xlsx) format. Large datasets may take a few moments to
                process.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
